import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { PayloadAction } from '@reduxjs/toolkit';
import { TCreateReleaseEarmarkReduxParams } from '~types/feat/customer';

export default function* watchCreateReleaseEarmark(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerUpdateReleaseEarmarkAttempt', handleCreateReleaseEarmark, api);
}

function* handleCreateReleaseEarmark(api: CustomerGateway, action: PayloadAction<TCreateReleaseEarmarkReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const customerId = reduxState.customer.customerDetails.customerId;

    const { transactionId } = action.payload;

    if (!transactionId) {
        toast.error(ErrorMessages.GenericError);
        return;
    }

    const response = yield* call([api, api.createReleaseEarmark], {
        authToken,
        transactionId: transactionId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(
            combinedActions.customerUpdateReleaseEarmarkFailure(
                response.message || ErrorMessages.GenericError
            )
        );
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    yield put(combinedActions.customerUpdateReleaseEarmarkSuccess());
    yield put(combinedActions.customerResetReleaseEarmarkState());
    yield put(combinedActions.customerSetConfirmUpdateReleaseEarmarkModalIsOpen(false));
    yield put(combinedActions.customerGetCustomerTransactionsAttempt({ customerId }));

    toast.success(SuccessMessages.CustomerReleaseEarmarkSuccess);
}

